import { useCallback, useEffect, useState } from 'react';
import { HttpMethod, HttpWrapper } from '../../../../../helpers/httpWrapper';
import { ICommunity } from '../../../../../networked-shared-interfaces/interfaces-phase2/platform-admin/platform-admin';
import { URLWrapper } from '../../../../../networked-shared-interfaces/url-wrapper';

interface ICommunityGateState {
	community: ICommunity | null;
	communityName: string;
	layer: number | null;
	loading: boolean;
	notFound: boolean;
}

export const useNetworkPlusCommunity = (communityId: string) => {
	const [state, setState] = useState<ICommunityGateState>({
		community: null,
		communityName: '',
		layer: null,
		loading: true,
		notFound: false,
	});

	const fetchCommunity = useCallback(() => {
		if (!communityId) {
			setState(s => ({ ...s, loading: false, notFound: true }));
			return;
		}

		setState(s => ({ ...s, loading: true }));

		HttpWrapper.callUrl(
			URLWrapper.urls.platformAdmin.community,
			HttpMethod.GET,
			{ communityId, start: 0, count: 1 },
			undefined
		)
			.then((res: any) => {
				const community = res?.community ?? res;
				const data: ICommunity | undefined = community?.content?.[0];
				setState({
					community: data ?? null,
					communityName: data?.name ?? '',
					layer: data?.layer ?? null,
					loading: false,
					notFound: data?.layer !== 0,
				});
			})
			.catch(() => {
				setState({ community: null, communityName: '', layer: null, loading: false, notFound: true });
			});
	}, [communityId]);

	useEffect(() => {
		fetchCommunity();
	}, [fetchCommunity]);

	return { ...state, refetch: fetchCommunity };
};
